<template>
  <div class="main-left-top">
    <div class="main-left-header" @click="toIndexPath">
      <span class="line"></span>
      {{ $lang('极兔API简介') }}
    </div>

    <div class="main-left-aside">
       <el-menu
       router
       ref="openApiMenu"
       active-text-color="#C31422"
      :default-active="activeIndex == '/apiDoc/index'?null:activeIndex"
      class="api-menu-vertical">
      <el-submenu v-for="(menuItem,menuIndex) in asideList" :index="`menu${menuIndex}`"  :key="menuIndex">
        <template slot="title">
          <span>{{$lang(menuItem.title)}}</span>
        </template>
          <el-menu-item v-for="subItem in menuItem.subTitle"
          :key="subItem.path"
          :index="subItem.path">{{$lang(subItem.title)}}</el-menu-item>
      </el-submenu>
    </el-menu>


<!--     <div class="main-left-aside-item" v-for="(item,index) in asideList" :key="index">-->
<!--        <div class="title">{{item.title}}</div>-->

<!--        <div-->
<!--          class="subTitle"-->
<!--          v-for="(subItem,subIndex) in item.subTitle"-->
<!--          :key="subIndex"-->
<!--        >-->
<!--          <span class="subTitle_click"-->
<!--          :class="{active:subItem.path==$route.path}"-->
<!--           @click.stop="subItem.path&&subItem.path!=$route.path&&$router.push(subItem.path)">{{subItem.title}}</span>-->
<!--        </div>-->

<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex:this.$route.path,
      asideList: [
        {
          title: "订单服务",
          subTitle: [
            {
              title: "在线下单",
              path: "/apiDoc/orderserve/create",
            },
            // {
            //   title: "查询订单",
            //   path: "/apiDoc/orderserve/query",
            // },
            {
              title: "取消订单",
              path: "/apiDoc/orderserve/cancel",
            },
          ],
        },
        {
          title: "面单服务",
          subTitle: [
            {
              title: "面单打印查询",
              path: "/apiDoc/vip/printOrder",
            },
          ],
        },
        {
          title: "物流轨迹",
          subTitle: [
            {
              title: "轨迹推送",
              path: "/apiDoc/logistics/statusFeedback",
            },
            {
              title: "轨迹查询",
              path: "/apiDoc/logistics/query",
            },
          ],
        },
      ]
    };
  },
  methods:{
    toIndexPath(){
      if(this.$route.path != '/apiDoc/index'){
          this.$router.push('/apiDoc/index');
          this.$refs.openApiMenu.activeIndex = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.api-menu-vertical{
  border-right: none;
  padding-bottom: 100px;
  ::v-deep .el-submenu__title{
    font-weight: 600;
  }
  ::v-deep .el-menu-item.is-active{
    font-weight: 600;
  }
}
.main-left-top{
    display: flex;
    flex-direction: column;
    height: 100%;
}
.main-left-header {
  position: relative;
  width: 100%;
  border-bottom: 1px solid $table-border-color;
  color: #2b2d42;
  font-size: 26px;
  font-weight: 900;
  line-height: 26px;
  padding: 22px 0 22px 20px;
  box-sizing: border-box;
  cursor: pointer;
  background: #fff;
  .line {
    width: 4px;
    height: 28px;
    background: $theme-color;
    border-radius: 2px;
    display: inline-block;
    position: absolute;
    left: 0;
    top: 22px;
  }
}

.main-left-aside {
  box-sizing: border-box;
  flex: 1;
  overflow: auto;
  max-height: 700px;
  .main-left-aside-item {
    .title {
      font-size: 14px;
      color: #2b2d42;
      box-sizing: border-box;
      padding: 10px 20px;
      line-height: 14px;
    }
    .subTitle {
      font-size: 14px;
      font-weight: 400;
      color: #61666d;
      line-height: 50px;
      text-align: center;
      .subTitle_click {
        cursor: pointer;
        &:hover {
          color: $theme-color;
        }
      }
    }
  }
  .active {
    color: $theme-color;
  }
}
</style>
